// 瑞典语
import constant from '../../constants/lang/sv';
import newLang from '../newLang/sv';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Snälla logga in först',
        404: 'Inga data',
        500: 'Systemet är upptaget, försök igen senare',
        504: 'Begäran tog för lång tid',
        ERR_NETWORK: 'Nätverk undantag',
        ERR_NETWORK_UPLOAD: 'Uppladdningen misslyckades, försök med ett annat nätverk',
      },
    },
    title: '智能网联国际版管理后台',
    navbar: {
      dropdown: {
        updatePassword: '修改密码',
        switchLanguage: '切换语言',
        logout: '退出登录',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'indikator ljus',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Spela in',
        'feedback-create': 'Återkoppling',
        'feedback-supplement': 'Ytterligare feedback',
        'feedback-detail': 'Information om feedback',
        'feedback-result': 'Återkoppling',
        guide: 'Hjälpcenter',
        'guide-restScreen': 'Boot-Hur du ställer in fordonet',
        'guide-overview': 'Översikt över funktioner',
        'guide-account': 'Om kontot',
        'guide-vehicle': 'Om fordonet',
        'guide-meterSetting': 'Hur du ställer in instrumentpanelen',
        'guide-vehicleSetting': 'Hur du ställer in fordonet',
        'guide-findNavigation': 'Hur man navigerar för att hitta fordonet',
        'guide-vehicleNnavigation': 'Hur man använder navigeringen',
        'guide-cyclingRecord': 'Om resehistorik',
        'guide-vehicleExperience': 'Så här utför du en egenkontroll av fordonet',
        'guide-useSetting': 'Hur man gör allmänna inställningar för APP',
        'guide-notice': 'Hur man visar och ställer in meddelandeavisering',
        'guide-about': 'Om APP',
        help: 'Hjälp och feedback',
        'help-detail': 'Fråga detaljer',
        'myCar-unbinding': 'Tillämpa avbindning',
        'myCar-unbinding-result': 'Tillämpa avbindning',
      },
    },
    form: {
      cancel: 'Annullera',
      confirm: 'Bekräfta',
      submit: 'Skicka in',
      language: {
        languageCode: {
          label: '请选择语言：',
          placeholder: '请选择语言',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: '请选择语言',
        },
      },
    },
    dialog: {
      language: '语言选择',
    },
    binding: {
      title: `Protokoll`,
      text1: '1.	Telematiktjänster _',
      text2:
        'CFMOTO Powersports, Inc. (hädanefter kallat " CFMOTO " ) tillhandahåller fordonstelematiktjänster till kunden som köpte CFMOTO-fordonet (nedan kallat "Kund" ). För dessa tjänster använder CFMOTO data som registrerats av Fordonet om Fordonet och dess körbeteende under den relevanta tidsperioden. I detalj handlar det om följande data:',
      text3: 'Data om användarens körbeteende : inklusive acceleration, retardation, hastighet, böjning, senaste körtid och senaste körsträcka .',
      text4:
        'Fordonsstatusdata: hänvisar till fordonets status i realtid, inklusive körläge, restbränsle, omedelbar bränsleekonomi, körsträcka, fordonets växel i realtid, motorvarvtal, däcktryck, däcktemperatur, batteriaktiveringsspänningsdata , kylvätsketemperatur, elektroniskt låsstatus, intelligent enhets mjukvaruversion, signalstyrka för smarta enheter, aktuell inställning av instrumentbrädan.',
      text5:
        'Fordonslarmdata: larmdata som ska skickas om vissa data överskrider ett förinställt värde, såsom motortemperatur, för hög hastighet, för lång körtid, hög kylvätsketemperatur, onormala fordonsrörelser, onormalt däcktryck, vibrationer, dumpning, kollision , etc. .',
      text6: 'Fordonsfelinformation: hänvisar till de felkoder som rapporteras av varje intern del av fordonet.',
      text7: 'Fordonsplatsdata: hänvisar till fordonets specifika geografiska vistelseort.',
      text8: '1.1.	Tillhandahålla ing kunden med fordonsrelaterade tjänster genom CFMOTO RIDE APP .',
      text9: '1.1.1.	Konsumenterna kan fjärrstyra fordon via CFMOTO RIDE APP (inklusive att visa fordonsplatsen, ställa in fordonsinformation och funktioner, fjärrkontroll av fordonsstatus, etc.).',
      text10: '1.1.2.	Tillhandahålla ruttplanering under navigering, inklusive beräkning av avståndet mellan fordon och gångnavigering i syfte att hitta ett fordon .',
      text11: '1.2.	Skicka nödvändiga aviseringar till kunden baserat på fordonets skick.',
      text12: '1.2.1.	CFMOTO kommer att avsluta kundens meddelanden om fordonsunderhåll (t.ex. baserat på den totala sträckan som kunden kör, tidpunkten när kunden köper fordonet, tiden eller kraven på körsträcka för fordonsunderhåll) .',
      text13: '1.2.2.	Baserat på fordonsdata kommer CFMOTO att skicka meddelanden om onormal situation till kunden ; inklusive dataanalys av OEM (beroende på modell) för att ge kundvård och uppföljningsoptimering av fordonet .',
      text14: '1.3.	Stöd vid analys av orsaken till olyckan om Kunden rapporterar en allvarlig olycka med Fordonet.',
      text15:
        '1.3.1.	I händelse av en allvarlig olycka med Fordonet, såsom när Fordonet välter eller välter på sidan under körning, kommer CFMOTO att stödja Kunden på begäran med att klargöra om olyckan beror på en defekt i Fordonet eller andra omständigheter. Begäran ska skickas till CFMOTO av kunden via den lokala distributören/försäljningspartnern som anges i fordonsförsäljningsavtalet.',
      text16: '1.3.2.	I den mån tillgängliga data tillåter detta kommer CFMOTO att utvärdera uppgifterna i förhållande till orsaken till olyckan och förse Kunden med en motsvarande rapport.',
      text17: '1.4.	Assistans för kunden att återställa Fordonet efter att Fordonet har förlorats .',
      text18: '1.4.1.	Om Fordonet försvinner kommer CFMOTO att förse Kunden med lokaliseringsdata för Fordonet och annan användbar statusdata för Fordonet (såsom plats för senaste aktivering, aktuell fordonsstatus, etc.) på begäran och om tillgänglig.',
      text19: '1.4.2.	Begäran ska skickas till CFMOTO av kunden via den lokala distributören/försäljningspartnern som anges i fordonsförsäljningsavtalet.',
      text20: '1.5.	Rapportering av eftermarknadsproblem .',
      text21: '1.5.1.	CFMOTO samlar in felkodsmeddelanden på distans som skickas av Fordonet i händelse av fel på dess komponenter och tillhandahåller respektive information på Kundens begäran direkt till Kunden.',
      text22: '1.5.2.	Begäran ska skickas till CFMOTO av kunden via den lokala distributören/försäljningspartnern som anges i fordonsförsäljningsavtalet.',
      text23: '2.	Begränsningar och undantag för tjänsten',
      text24:
        '2.1.	Det påpekas uttryckligen att strukturella eller andra tekniska förändringar av Fordonet kan begränsa tillhandahållandet av tjänsterna eller till och med göra det omöjligt, eftersom tjänsterna är beroende av korrekt tillhandahållande av fordonsdata.',
      text25: '2.2.	Där sådana tjänster inte kan tillhandahållas på grund av prestanda hos någon tredje parts data- eller telekommunikationsnätverk, är CFMOTOs ansvar uteslutet.',
      text26: '3.	Integritet',
      text27:
        'CFMOTO kommer att följa gällande dataskyddsbestämmelser vid behandling av personuppgifter i samband med CFMOTO- fordonet . Villkoren för C FMOTOs integritetspolicy anges i denna CFMOTO RIDE- APP. Som ett komplement till integritetspolicyn överensstämmer hans meddelande med integritetspolicyn . Och kunden kan hänvisa till integritetspolicyn för visst databehandlingsrelaterat innehåll som inte täcks av detta meddelande.',
      text28: '4.	Kundservice',
      text29:
        '4.1.	Kunden kan gärna skicka sekretessrelaterade frågor , kommentarer eller bekymmer till CFMOTORIDEAPP@cfmotousa.com eller skriva till: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Kunden kan också ringa CFMOTO kundrelationer på (888) 823-6686. ',
      text30: '5.	R evisioner',
      text31: '5.1.	CFMOTO förbehåller sig rätten att ändra detta meddelande när som helst, men vi kommer att publicera revisioner på CFMOTO RIDE App och/eller meddela innan vi gör det på lämpligt sätt.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'De nya inställningarna kommer att träda i kraft inom 1-3 minuter efter att fordonet slås på, se till att fordonet är i en bra signalposition',
      setSuccess: 'Ställ in framgångsrikt',
      sure: 'Säker',
      confirm: 'Bekräfta',
      cancel: 'Annullera',
      cContent: 'Inställningarna har inte sparats än, vill du spara dem?',
      save: 'Spara inställningar',
      introduce1: 'Instruktioner för nära automatisk upplåsning',
      introduce2: 'instruktioner för automatisk avstängning',
      introduce3: 'Instruktioner för automatisk väckning',
      introduce4: 'Fördröjda lampor släcks',
      content1: {
        msg1: 'När funktionen är påslagen slår mobiltelefonen på Bluetooth och APP fortsätter att köra. När du närmar dig fordonet långt till nära kan fordonet automatiskt låsas upp och slås på.',
        msg2: 'Om den normalt inte är olåst och påslagen trycker du på fordonets strömknapp för att låsa upp och slå på',
        msg3: 'Automatisk upplåsning av närhet utlöses bara en gång innan Bluetooth kopplas bort',
      },
      content2: {
        msg1: 'Efter att funktionen har slagits på stängs fordonet automatiskt av efter 5 sekunder efter att fordonets tre förhållanden har stängts av, fordonets hastighet är 0 och templet tappas',
        msg2: 'Starta fordonet under den automatiska avstängningsperioden, fordonets hastighet är inte 0, eller templet läggs bort kommer att avbryta den automatiska avstängningen',
      },
      content3: {
        msg1: 'När funktionen är påslagen, när fordonet stängs av, slår mobiltelefonen på Bluetooth och APP: n fortsätter att köra eller bär den fysiska nyckeln. När du närmar dig fordonet långt till nära blinkar fordonets lampor för att välkomna gästerna',
        msg2: 'För att förhindra att frekventa utlösare orsakar fordonets strömförlust, efter att välkomstfunktionen har utlösts två gånger inom 30 sekunder, återupptas den inte förrän 30 minuter senare',
      },
      content4: {
        msg1: 'Efter att funktionen har slagits på kommer fjärr- och halvljusljusen att tändas automatiskt i 10 sekunder efter att fordonet stängts av',
      },
    },
    feedback: {
      label: {
        type: 'Feedbacktyp (enkelval)',
        content: 'Problembeskrivning',
        fileList: 'Ladda upp en bild',
        fileList2: '(Högst 4 bilder / 1 video)',
        feedbackCreate: 'Klicka för att få återkoppling',
        feedbackSupplement: 'Ytterligare feedback',
        backHome: 'Tillbaka till hemsidan',
        vehicle: 'tillhörande fordon',
        selectVehicle: 'välj fordon',
      },
      placeholder: {
        'content.bug': 'Beskriv i detalj tidpunkten då problemet inträffade, APP-versionen, mobiltelefonmodellen, driftsvägen och problembeskrivningen så att vi snabbt kan lokalisera och felsöka problemet!',
        'content.suggest': 'Välkommen att lämna värdefulla förslag, vi kommer att ta dina idéer på allvar.',
        'content.vehicle': 'Beskriv när det hände, hur det hände och vilket problem det rörde sig om.',
        'content.other': 'Beskriv när det hände, hur det hände och vilket problem det rörde sig om.',
        'content.supplement': 'Lägg till en beskrivning av problemet',
        vehicle: 'Välj ett fordon',
      },
      rules: {
        'type.required': 'Välj en typ av feedback',
        'content.required': 'Ange en beskrivning av ditt problem',
        'fileList.uploading': 'Uppladdning, vänligen vänta..',
        'fileList.maxSize': 'Den uppladdade filen är för stor',
        'fileList.overType': 'Format som inte stöds',
        'fileList.maxCount': 'Antalet uppladdningar överskrider gränsen',
        'fileList.acceptImageVideo': 'Video kan inte väljas när du väljer bilder',
        'vehicle.required': 'Välj ett fordon',
      },
      message: {
        empty: 'För närvarande finns det inga återkopplingsregister.',
        finish: 'Svara',
        loading: 'Läser in',
        uploadFailed: 'Överföring misslyckades',
        tip: 'För att skydda ditt kontos säkerhet får du inte lämna in känslig personlig information här, t.ex. lösenord till konton osv. ',
        feedbackSuccess: 'Feedback mottagen',
        'submit.error': 'Återkoppling misslyckades',
        'submit.success': 'Feedback mottagen',
      },
    },
    guide: {
      label: { giveFeedback: 'Oupplöst, jag vill ge feedback' },
    },
    help: {
      label: {
        history: 'Sök poster',
        cancel: 'Häva',
        yes: 'Ja',
        no: 'Nej',
        unresolved: 'Kan du fortfarande inte lösa? Klick',
        submitFeedback: 'Skicka feedback',
      },
      placeholder: {
        search: 'Sök',
        'content.required': 'Vänligen ange nyckelord',
      },
      message: {
        empty: 'Inget relaterat innehåll',
        empty2: 'Föreslå att du ändrar sökord eller',
        finish: 'Svara',
        historyDelete: 'Ta bort alla sökposter?',
        isHelpful: 'Hjälper det?',
      },
    },
    unbinding: {
      label: {
        vin: 'VIN',
        realName: 'Ditt fulla namn',
        email: 'E-postadress',
        phone: 'Telefonnummer',
        areaCode: 'Landskod',
        identity: 'Identifiering',
        drivingLicense: 'Fordonsregistreringsbevis.',
        backHome: 'Tillbaka till hemsidan',
        areaCodeTitle: 'Landskod',
        latterTitle: 'Lägga märke till',
        agree: ' Godkännande',
        disagree: 'Inte överens',
        agreeCheckLabel: ' Jag har läst och accepterar',
        agreeCheckTitle: 'Anvisningar för att ansöka om fordonsfrigörande',
      },
      placeholder: {
        vin: 'Vänligen ange VIN',
        realName: 'Ange ditt riktiga namn',
        email: 'Var god skriv in din e-postadress',
        phone: 'Vänligen skriv in ditt telefonnummer',
        identity: 'Huvudsidan av ID-kort, körkort eller pass som innehåller personlig identifikationsinformation.',
        drivingLicense: 'Fordonsregistreringsbevisets huvudsida med ägarens namn och VIN.',
      },
      rules: {
        'agree.required': 'Vänligen läs och godkänn',
        'vin.required': 'Vänligen ange VIN',
        'vin.pattern': 'Felaktig VIN, vänligen kontrollera.',
        'realName.required': 'Ange ditt riktiga namn',
        'email.required': 'Var god skriv in din e-postadress',
        'email.pattern': 'Felaktigt format på e-postadressen, var vänlig kontrollera.',
        'phone.required': 'Vänligen skriv in ditt telefonnummer',
        'phone.pattern': 'Fel i formatet på telefonnumret, kontrollera',
        'fileList.maxCount': 'Antalet uppladdningar överskrider gränsen',
        'fileList.uploading': 'Uppladdning, vänligen vänta',
      },
      message: {
        imgUploadFailed: 'Det gick inte att ladda upp bilden',
        securityMessage: 'Ovanstående information används endast för identitetsverifiering. CFMOTO skyddar din information.',
        resultMessage: 'Vi kommer att verifiera applikationsmaterialet så snart som möjligt, var uppmärksam på meddelandefältet eller APP-meddelandecentret i tid.',
        loading: 'Läser in',
      },
    },
  },
};
